export const filterSavedData = (savedAds, uid) => {
	const adToDelete = savedAds.find(property => property.uid === uid);
	if (!!adToDelete) {
		return savedAds.filter(property => property.uid !== uid);
	}

	return savedAds;
};
